import {useContext, useMemo} from 'react';
import {UserContext} from '../contexts/UserContext';
import {IUserContext} from '../@interfaces/contexts/IUserContext';

export default function usePermissions(): Required<Pick<IUserContext, 'can' | 'canAny' | 'cant' | 'cannotAny'>> {
    const userContext = useContext(UserContext);

    return useMemo(() => {
        return {
            can(...permissions): boolean {
                return userContext?.can(...permissions) ?? false;
            },

            cant(...permissions): boolean {
                return userContext?.cant(...permissions) ?? false;
            },

            canAny(...permissions): boolean {
                return userContext?.canAny(...permissions) ?? false;
            },

            cannotAny(...permissions): boolean {
                return userContext?.cannotAny(...permissions) ?? false;
            }
        };
    }, [userContext]);
}
